import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { GetOrdersFilterLimitsResponse } from "./getOrdersFilterLimits.types";

export const requestGetOrdersFilterLimits =
  async (): Promise<GetOrdersFilterLimitsResponse> => {
    return await instance.get(ApiRoutesOrders.OrdersFilterLimits);
  };
